/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Columns/theme';

export const ColumnsTheme = theme;
